import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { SessionContextProvider } from "@supabase/auth-helpers-react";
import { createClient } from "@supabase/supabase-js";
import { PostHogProvider} from 'posthog-js/react'
import posthog from 'posthog-js'


const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}
const supabase = createClient("https://mzovfnxteplyeeckgsyj.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im16b3Zmbnh0ZXBseWVlY2tnc3lqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTMwMzg2ODIsImV4cCI6MjAyODYxNDY4Mn0.khPxrT2ESnpGSMSryIXRrZn_K9ke6vT5nCldiM-i0wo")


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
        <PostHogProvider 
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    ></PostHogProvider>
    <SessionContextProvider supabaseClient={supabase}>
    <App />
    </SessionContextProvider>
  </React.StrictMode>
);

// 
